let _registration = null;
export function setSwRegistration(reg) {
    _registration = reg;
}
export function applySwUpdate() {
    // Mark that we're applying an update so we don't show the banner again after reload or restart
    localStorage.setItem('sw-update-accepted', 'true');
    _registration?.waiting?.postMessage({ type: 'SKIP_WAITING' });
}
